import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import axios from 'axios'
import { Layout, AlertContext } from '../widgets'
import * as routes from '../routes'
import {
  Loading,
  withProfileCompleteness,
  withRouter,
} from '../shared'
import { BeatCell } from '../components'

const ProducerBeats = (props) => {
  const [state, replaceState] = useState({
    loading: true,
    beats: [],
    current_offset: 0,
    next_offset: 0,
    boost_purchase_result: queryString.parse(props.router.location.search).boost_purchase_result
  })

  const setState = (subState) => {
    replaceState(state => {
      return {...state, ...subState}
    })
  }

  const { showAlert, showAlertError, showAlertConfirm, showToast, handleError } = useContext(AlertContext)

  useEffect(() => {
    load([], state.current_offset)
  }, [])

  useEffect(() => {
    if (state.boost_purchase_result === 'success') {
      showAlert({
        title: 'Purchase Complete',
        message: <>
          <div>Your beat is now being boosted in the Hot feed!</div>
          <br/>
          <div>You will receive a purchase email confirmation shortly.</div>
        </>,
        callback: () => {
          setState({ boost_purchase_result: null })
        }
      })
    }
  }, [state.boost_purchase_result])

  const load = (existingBeats, offset) => {
    axios.get(routes.getBeatsPrivateUserUrl, {
      params: {
        offset: offset,
      }
    }).then((response) => {
      setState({
        beats: existingBeats.concat(response.data.beats),
        current_offset: offset,
        next_offset: response.data.next_offset
      })
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setState({ loading: false })
    })
  }

  const onShare = (beat) => {
    navigator.clipboard.writeText(beat.share_url).then(() => {
      showToast('Link copied to clipboard.')
    }, (err) => {
      showToast('Could not copy the track to your clipboard!')
    })
  }

  const onEdit = (beat) => {
    props.router.navigate(routes.dynamic(routes.producerBeatsEditPath, beat.id))
  }

  const onDelete = (beat) => {
    showAlertConfirm({
      title: 'Confirm Beat Deletion',
      message: 'Are you sure you want to delete your beat? It will no longer be available to others.',
      callback: () => {
        setState({ loading: true })
        axios.delete(routes.deleteBeatUrl, {
          data: {
            item_id: beat.id
          }
        }).then(() => {
          load([], 0)
        }).catch((error) => {
          handleError(error)
        }).finally(() => {
          setState({ loading: false })
        })
      }
    })
  }

  const onBoost = (beat) => {
    props.router.navigate(routes.dynamic(routes.producerPurchaseBeatBoostPath, beat.id))
  }

  if (state.loading) {
    return <div className='body-container'>
      <Layout>
        <Loading />
      </Layout>
    </div>
  }

  const beatsTable =
    state.beats.length <= 0 ? (
      <div className='user-content-none'>
        Looks like you don't have any beats yet.{' '}
        <Link to={routes.producerSubmitPath}>Upload Music Here.</Link>
      </div>
    ) : (
      <div>
        <div className='layout-content'>
          {state.beats.map((beat, index) => <BeatCell beat={beat} key={index} onShare={onShare} onEdit={onEdit} onDelete={onDelete} onBoost={onBoost}/>)}
        </div>
        {state.next_offset >= 0 && (
          <a href='#'
            onClick={e => {
              e.preventDefault()
              load(state.beats, state.next_offset)
            }}
          >
            See More
          </a>
        )}
      </div>
    )

  const content = (
    <Layout>
      <Layout.Header>Beats</Layout.Header>
      {beatsTable}
    </Layout>
  )

  return (
    <div className='body-container'>
      {withProfileCompleteness(content)}
    </div>
  )
}

export default withRouter(ProducerBeats)
